import { render } from "./gold-dealer.vue?vue&type=template&id=13b196aa&scoped=true&ts=true"
import script from "./gold-dealer.vue?vue&type=script&lang=ts"
export * from "./gold-dealer.vue?vue&type=script&lang=ts"

import "./gold-dealer.vue?vue&type=style&index=0&id=13b196aa&lang=scss&scoped=true"

import exportComponent from "/Users/panren/Desktop/太平洋网络/discount-topics-wap-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b196aa"]])

export default __exports__